import {LaborCost} from '../../app/model/labor-cost';

export const laborCosts: LaborCost[] =
  [
    {
      'level': 0,
      'modifier': 1.0
    },
    {
      'level': 1,
      'modifier': 0.8
    },
    {
      'level': 2,
      'modifier': 0.75
    },
    {
      'level': 3,
      'modifier': 0.7
    },
    {
      'level': 4,
      'modifier': 0.65
    },
    {
      'level': 5,
      'modifier': 0.6
    },
    {
      'level': 6,
      'modifier': 0.55
    },
    {
      'level': 7,
      'modifier': 0.5
    }
  ];
